// extracted by mini-css-extract-plugin
module.exports = {"NoData":"NoData_NoData__jgCN_"};